import { Point } from './types';

export const addresses: Point[] = [
  {
    id: 'id-1',
    address: "​площадь Тверская Застава, 7",
    coords: [55.776882,37.581352]
  },
  {
    id: 'id-2',
    address: "улица Пришвина, 9/2",
    coords: [55.889594303926216,37.597515676367344]
  },
  {
    id: 'id-3',
    address: "Софийская набережная, к1",
    coords: [55.745564,37.616153]
  },
  {
    id: 'id-4',
    address: "Сходненская улица, 28А",
    coords: [55.84110328193075,37.44017268880225]
  },
  {
    id: 'id-5',
    address: "​улица Ильинка, 6/1 ст1",
    coords: [55.754638,37.626277]
  },
  {
    id: 'id-6',
    address: "Шарикоподшипниковская, 3",
    coords: [55.723131,37.667788]
  },
  {
    id: 'id-7',
    address: "Ельнинская улица, 20к2",
    coords: [55.73967095200726,37.42176200612403]
  },
  {
    id: 'id-8',
    address: "Симферопольский бульвар, 20 к1",
    coords: [55.649383,37.604421]
  },
  {
    id: 'id-9',
    address: "улица Коминтерна, 15",
    coords: [55.87152609123505,37.689225767004565]
  },
  {
    id: 'id-10',
    address: "Большая Черкизовская улица, 5к2",
    coords: [55.797991129541295,37.71903465052342]
  },
  {
    id: 'id-11',
    address: "Вольная улица, 5",
    coords: [55.77680838254009,37.72530029078222]
  },
  {
    id: 'id-12',
    address: "Сормовская улица, 10/2",
    coords: [55.71000901732429,37.809341444201]
  },
]

export const PAGE_SIZE = 9;